import { memo } from 'react';
import classNames from 'classnames';

import Svg from '../../../svg/svg.component';

import './nav-item-outbound-icon.scss';

export interface NavItemOutboundIconProps {
  className?: string;
}

export const NavItemOutboundIcon = memo(({ className }: NavItemOutboundIconProps) => {
  return (
    <span className={classNames('snowflake-mega-nav-nav-item-stick-icon-to-text', className)}>
      {' '}
      {/* This space character is necessary for making sure the outbound icon "sticks" to the text, so the icon does not wrap to a new line by itself. */}
      <Svg name="outbound-link" data-testid="button-link-icon" className="link-icon" />
    </span>
  );
});

NavItemOutboundIcon.displayName = 'NavItemOutboundIcon';
